import { WorkflowInstance as OctopusWorkflowInstance } from '../models';
import { WorkflowInstance } from '../../../models';
import { Mapper } from '../../../mappers';

export class WorkflowInstanceMapper extends Mapper<
  OctopusWorkflowInstance[],
  WorkflowInstance[]
> {
  from(source: OctopusWorkflowInstance[]): WorkflowInstance[] {
    return source.map(
      (item) =>
        ({
          key: item.Key,
          workflowKey: item.WorkflowKey,
          workflowStageKey: item.WorkflowStageKey ?? null,
          workflowTaskTemplateKey: item.WorkflowTaskTemplateKey ?? null,
          parentKey: item.ParentKey,
          completed: item.Completed,
          creationDate: item.CreationDate?.Value ?? '',
          lastModifyDate: item.LastModifyDate?.Value ?? '',
          withKey: item.WithKey,
        }) as WorkflowInstance,
    );
  }
}
